import { defineNuxtPlugin, useRouter } from "nuxt/app";
import VueMatomo from "vue-matomo";
import { NUXT_MATOMO_URL } from "~/types/env";
import { getCurrentUuId } from "~/utils/route";

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  nuxtApp.vueApp.use(VueMatomo, {
    router,
    host: NUXT_MATOMO_URL,
    siteId: 1,
    enableLinkTracking: true,
    trackerFileName: "matomo",
    logger: true,
    userId: getCurrentUuId() || null,
  });
});

// var _paq = [];
// _paq.push(["trackPageView"]);
// _paq.push(["enableLinkTracking"]);
// (function () {
//   var u = "//47.107.233.127:8080/";
//   _paq.push(["setTrackerUrl", u + "matomo.php"]);
//   _paq.push(["setSiteId", "1"]);
//   var d = document,
//     g = d.createElement("script"),
//     s = d.getElementsByTagName("script")[0];
//   g.async = true;
//   g.src = u + "matomo.js";
//   s.parentNode.insertBefore(g, s);
// })();
